import ActionTypes from "../actionTypes/actionTypes";

const DEFAULT_STATE = {
    previous: null,
    current: null,
    params: null
};

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case ActionTypes.SET_VIEW : {
            return Object.assign({}, state, {
                previous: state.current,
                current: action.view,
                params: action.params
            });
        }
        default:
            return state        
    }
}